export default __webpack_public_path__ + "static/media/close.aac123e0.svg";